<script setup>
import { BIconXCircleFill } from "bootstrap-icons-vue";
import { ref } from "vue";

const emit = defineEmits(["remove-tag"]);
const props = defineProps({
  tag: {
    type: String,
    default: null,
  },
});

const isHovered = ref(false);

const setIsHovered = (value) => {
  isHovered.value = value;
};

const removeTag = () => {
  emit("remove-tag", props.tag);
};
</script>

<template>
  <div
    @mouseenter="setIsHovered(true)"
    @mouseleave="setIsHovered(false)"
    class="tag rounded d-flex align-items-center"
  >
    <span>{{ tag }}</span>
    <BIconXCircleFill
      v-if="isHovered"
      class="ms-2 close-icon"
      @click.stop="removeTag"
    />
  </div>
</template>

<style scoped lang="scss">
.tag {
  padding: 4px 8px;
  font-size: 12px;
  width: fit-content;
  background: $neutral-150;
  color: $neutral-400;
  border-radius: 4px;

  .close-icon {
    margin-top: 2px;
  }
}
</style>
